  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import IconButton                                          from '@material-ui/core/IconButton';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  //----------------
  // core components
  //----------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_BillsService }                                 from "../../_services";
//import { wu_CountriesStatesCitiesService }                 from "../../_services";
//import { wu_CurrenciesService }                            from "../../_services";
  import { wu_ServiceAvailabilityService }                   from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import BillsStyle                                   from "./BillsStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import wu_bills_grayArrow                                  from "assets/img/wu/wu_bills_grayArrow.svg";

  //header menu Images
  import Bills_header_home                                   from "assets/img/wu/Bills_header_home.svg";
  import Bills_header_categories                             from "assets/img/wu/Bills_header_categories.svg";
  import Bills_header_history                                from "assets/img/wu/Bills_header_history.svg";
  import Bills_header_favorites                              from "assets/img/wu/Bills_header_favorites.svg";
//import Bills_header_scan                                   from "assets/img/wu/Bills_header_scan.svg";

  import Bills_Company_Placeholder                           from "assets/img/wu/Bills_Company_Placeholder.svg";

  import SearchIcon                                          from "@material-ui/icons/Search";
  //----------
  // variables
  //----------
  const filename = "Bills ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  //header menu - Autocomplete
  const AUTOCOMPLETE_MIN_CHARACTERS_OPEN_POPUP = 1000;    //
  const AUTOCOMPLETE_FILTER_OPTIONS            = "start"; //"start","any"
  const AUTOCOMPLETE_KEYWORDS_LANG_ALL         = true;    //true=greek and english together
  const AUTOCOMPLETE_KEYWORDS_KEYS_ALL         = ["nameEl","nameEn",];

class Bills extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      lbl_noFavorites_isHidden                             : true,

      btn_favorite01_isHidden                              : true,
      btn_favorite02_isHidden                              : true,
      btn_favorite03_isHidden                              : true,
      btn_favorite04_isHidden                              : true,
      btn_favorite01                                       : "",
      btn_favorite02                                       : "",
      btn_favorite03                                       : "",
      btn_favorite04                                       : "",

      parserObject_categoriesList                          : [],
      parserObject_bills_billsHistory_res                  : [],
      parserObject_bills_favoritelist_res                  : [],

      //header menu - state
      Bills_header_home                                    : Bills_header_home,
      Bills_header_categories                              : Bills_header_categories,
      Bills_header_history                                 : Bills_header_history,
      Bills_header_favorites                               : Bills_header_favorites,
    //Bills_header_scan                                    : Bills_header_scan,

      autoCompleteSearchEnabled                            : api.autoCompleteSearchEnabled, //newSearchEnabled
      textField1                                           : "",
      textField1_inputValue                                : "",
      textField1_hasError                                  : false,
      textField1_popoverOpen                               : false,

      canSearchRF                                          : true,
      searchResults_isHidden                               : true,
      searchResults_arr                                    : true,

      //popup checkAppVersion
      dialog_checkAppVersion_isOpen                        : false,
      dialog_checkAppVersion_msg                           : "",

      //popup bpdone
      dialog_bpdone_msg                                    : "",
      dialog_bpdone_isOpen                                 : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //header menu - bindings
    this.handleCustomDropDownClick_headerMenu_change                 = this.handleCustomDropDownClick_headerMenu_change.bind(this);
    this.handleCustomDropDownClick_headerMenu_close                  = this.handleCustomDropDownClick_headerMenu_close.bind(this);
    this.headerMenu_btn_search_isDisabled                            = this.headerMenu_btn_search_isDisabled.bind(this);
    this.headerMenu_btn_search_with_enter                            = this.headerMenu_btn_search_with_enter.bind(this);
    this.headerMenu_btn_search_with_icon                             = this.headerMenu_btn_search_with_icon.bind(this);
    this.headerMenu_btn_search_logic                                 = this.headerMenu_btn_search_logic.bind(this);
    this.Bills_header_scan_act                                       = this.Bills_header_scan_act.bind(this);
    this.Bills_header_home_act                                       = this.Bills_header_home_act.bind(this);
    this.Bills_header_categories_act                                 = this.Bills_header_categories_act.bind(this);
    this.Bills_header_history_act                                    = this.Bills_header_history_act.bind(this);
    this.Bills_header_favorites_act                                  = this.Bills_header_favorites_act.bind(this);

    this.buildUI                                                     = this.buildUI.bind(this);

    this.onListItemClick_transaction                                 = this.onListItemClick_transaction.bind(this);
    this.onListItemClick_company                                     = this.onListItemClick_company.bind(this);

    this.get_logoUrl_FromObj                                         = this.get_logoUrl_FromObj.bind(this);
    this.get_companyNameHistory_FromObj                              = this.get_companyNameHistory_FromObj.bind(this);
    this.get_companyName_FromObj                                     = this.get_companyName_FromObj.bind(this);
    this.get_date_FromObj                                            = this.get_date_FromObj.bind(this);
    this.get_amount_FromObj                                          = this.get_amount_FromObj.bind(this);
    this.get_status_FromObj                                          = this.get_status_FromObj.bind(this);
    this.get_statusColor_FromObj                                     = this.get_statusColor_FromObj.bind(this);

    this.btn_favorite01_act                                          = this.btn_favorite01_act.bind(this);
    this.btn_favorite02_act                                          = this.btn_favorite02_act.bind(this);
    this.btn_favorite03_act                                          = this.btn_favorite03_act.bind(this);
    this.btn_favorite04_act                                          = this.btn_favorite04_act.bind(this);

    this.bills_enrich_billsHistory                                   = this.bills_enrich_billsHistory.bind(this);

    this.makeHTTPConn_bills_info_inputSingleRF                       = this.makeHTTPConn_bills_info_inputSingleRF.bind(this);

    this.process_CategoriesCompaniesObject                           = this.process_CategoriesCompaniesObject.bind(this);

    //popup checkAppVersion
    this.dialog_checkAppVersion_handleOpen                           = this.dialog_checkAppVersion_handleOpen.bind(this);
    this.dialog_checkAppVersion_btn_ok                               = this.dialog_checkAppVersion_btn_ok.bind(this);

    //popup bpdone
    this.dialog_bpdone_handleOpen                                    = this.dialog_bpdone_handleOpen.bind(this);
    this.dialog_bpdone_btn_ok                                        = this.dialog_bpdone_btn_ok.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ localStorage.setItem("CustomerWantedToLoginToBills","true"); wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      localStorage.setItem("CustomerWantedToLoginToBills","true"); wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering---load Contoller---Exclude(LIGHT)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    //if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //-------------
    //Do some reset
    //-------------
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    localStorage.setItem("bills_billsHistoryDetail_FLOW","bills_billsHistoryDetail_FLOW_HISTORY");
    try{     Cookies.set('bills_billsHistoryDetail_FLOW',"bills_billsHistoryDetail_FLOW_HISTORY", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //--------------
    //triggerRefresh
    //--------------
    wu_Utilities.triggerRefreshCheck("triggerRefresh_Bills","triggerRefresh_Bills_LastDate", 45);

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="BillsHistoryDetail" && localStorage.getItem("triggerRefresh_Bills")!=="true"){
      localStorage.setItem("triggerRefresh_Bills","false");
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      return;
    }
    if(localStorage.getItem("prev_view").trim()==="BillsFavoritesDetail" && localStorage.getItem("triggerRefresh_Bills")!=="true"){
      localStorage.setItem("triggerRefresh_Bills","false");
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      return;
    }

    //-------------------------
    //wu_getCategoriesCompanies---CACHED
    //-------------------------
    let retrieveWSData_getCategoriesCompanies = wu_BillsService.wu_should_getCategoriesCompanies();
    if(api.print_logs){console.log("retrieveWSData_getCategoriesCompanies="+retrieveWSData_getCategoriesCompanies);}
    if(retrieveWSData_getCategoriesCompanies){
      wu_BillsService
      .wu_getCategoriesCompanies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="Bills"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
      });
    }
    else{
      try{
        //let res = JSON.parse(localStorage.getItem("categoriescompanies"));
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn() {
    let methName = filename+"makeHTTPConn ";
    if(api.print_logs){console.log(methName);}

    //header menu - Keywords
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}
    let getLocations_keywords_vals_all = wu_Utilities.extractKeywordsFromJSON(parserObject_categoriesCompaniesList,AUTOCOMPLETE_KEYWORDS_KEYS_ALL);
    console.log(methName+'getLocations_keywords_vals_all='+getLocations_keywords_vals_all.length+'=>'+getLocations_keywords_vals_all);
    this.setState({ "getLocations_keywords_vals_all": getLocations_keywords_vals_all });

    let parserObject_bills_billsHistory_req = {};
    parserObject_bills_billsHistory_req["count"]     = "10";  //"10"
    parserObject_bills_billsHistory_req["startDate"] = "";    //"2023-01-01"
    parserObject_bills_billsHistory_req["endDate"]   = "";    //"2023-12-31"

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------------
      //wu_bills_billshistory
      //---------------------
      wu_BillsService
      .wu_bills_billshistory(parserObject_bills_billsHistory_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="Bills"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        localStorage.setItem("parserObject_bills_billsHistory_res", this.bills_enrich_billsHistory(res.payments));
        this.setState({ "parserObject_bills_billsHistory_res": this.bills_enrich_billsHistory(res.payments) });
        this.stopSpinners();
        this.serviceAvailability();
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err)+" err="+err);
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  serviceAvailability(){
    let methName = filename+"serviceAvailability ";
    if(api.print_logs){console.log(methName);}

    //-------------------
    //serviceAvailability---CACHED
    //-------------------
    let retrieveWSData_serviceAvailability = wu_ServiceAvailabilityService.wu_should_callServiceAvailability();
    if(retrieveWSData_serviceAvailability){
      this.startSpinners();
      wu_ServiceAvailabilityService
      .wu_serviceAvailability({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="Bills"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.stopSpinners();
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_serviceAvailability="+retrieveWSData_serviceAvailability);}
        if(res.bpAvailable ==="0"){this.dialog_handleOpen(res.returnText);}
        this.checkAppVersion();//this.makeHTTPConn_bills_favoritelist();
      })
      .catch(err => {
        //this.stopSpinners();
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_serviceAvailability="+retrieveWSData_serviceAvailability);}
        this.checkAppVersion();//this.makeHTTPConn_bills_favoritelist();
      });
    }
    else{
      try{
        //this.stopSpinners();
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_serviceAvailability="+retrieveWSData_serviceAvailability);}
        this.checkAppVersion();//this.makeHTTPConn_bills_favoritelist();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  checkAppVersion(){
    let methName = filename+"checkAppVersion ";
    if(api.print_logs){console.log(methName);}

    //---------------
    //checkAppVersion---CACHED
    //---------------
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let retrieveWSData_checkAppVersion = wu_AppVersion.wu_should_checkAppVersion();
    if(retrieveWSData_checkAppVersion){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="Bills"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        if(res.isMajorUpdate===true){
          this.dialog_checkAppVersion_handleOpen(res.returnText);
          return;
        }
        this.makeHTTPConn_bills_favoritelist();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        this.makeHTTPConn_bills_favoritelist();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        this.makeHTTPConn_bills_favoritelist();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_bills_favoritelist() {
    let methName = filename+"makeHTTPConn_bills_favoritelist ";
    if(api.print_logs){console.log(methName);}

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------------
      //wu_bills_favoritelist
      //---------------------
      wu_BillsService
      .wu_bills_favoritelist({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="Bills"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        localStorage.setItem("parserObject_bills_favoritelist_res", JSON.stringify(res.favorites));
        this.setState({ "parserObject_bills_favoritelist_res": res.favorites });
        this.stopSpinners();
        this.buildUI()
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err)+" err="+err);
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_bills_info_inputSingleRF() {
    let methName = filename+"makeHTTPConn_bills_info_inputSingleRF ";
    if(api.print_logs){console.log(methName);}

    var parserObject_bills_info_inputSingleRF_req = {};
    parserObject_bills_info_inputSingleRF_req["rfPaymentCode"] = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    localStorage.setItem("parserObject_bills_info_inputSingleRF_req", JSON.stringify(parserObject_bills_info_inputSingleRF_req));

    localStorage.setItem("billPaymentSetup_ws","inputSingleRF");

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));}
    //this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------------
      //wu_bills_favoritelist
      //---------------------
      wu_BillsService
      .wu_bills_info_inputSingleRF(parserObject_bills_info_inputSingleRF_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="Bills"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        var parserObject_bills_payment_info_generic_res = res.fields;
        parserObject_bills_payment_info_generic_res.sort(function(a, b) {
          if( (a.order+"").localeCompare(b.order+"") === -1){ return -1; }
          if( (a.order+"").localeCompare(b.order+"") === 1){ return 1; }
          return 0;
        });
        localStorage.setItem("parserObject_bills_payment_info_generic_res", JSON.stringify(parserObject_bills_payment_info_generic_res));
        this.setState({ "parserObject_bills_payment_info_generic_res": parserObject_bills_payment_info_generic_res });

        try{ String(localStorage.setItem("bills_billerId",res.billerId));}catch(err){console.log(methName+'err='+err);}
        //+++++++++++++++++
        //BillsPaymentSetup
        //+++++++++++++++++
        localStorage.setItem("BillsPaymentSetup_prev_view","Bills");
        history.push(wu_Utilities.getNavigationURLs("BillsPaymentSetup"));
      })
      .catch(err => {
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"err="+JSON.stringify(err)+" err="+err);
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    let defaultPropsCountry = {};
    if(AUTOCOMPLETE_KEYWORDS_LANG_ALL===true){
      defaultPropsCountry = { options:this.state.getLocations_keywords_vals_all, getOptionLabel:option => option, };
    }
    else{
      defaultPropsCountry = { options:localStorage.getItem("lang")==="en" ? this.state.getLocations_keywords_vals_en : this.state.getLocations_keywords_vals_el, getOptionLabel:option => option, };
    }
    const filterOptions = createFilterOptions({
      matchFrom: AUTOCOMPLETE_FILTER_OPTIONS,
      stringify: option => option,
    });

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={api.columns_bills_sm} md={api.columns_bills_md}>

            <GridContainer justify="center">
              <GridItem xs={2} sm={2} md={1}>
                <div style={{ marginTop:10,marginBottom:10, textAlign:"left" }}>
                  {/* ----------[goBack]------------ */}
                  {/* <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button> */}
                </div>
              </GridItem>
              {/* <GridItem xs={10} sm={10} md={11}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("Bills_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem> */}
            </GridContainer>
            {/* -------------------------------- */}
            {/* ----------[//Header Menu]------- */}
            {/* -------------------------------- */}
            <div style={{ padding:5, marginTop:10, textAlign : "center",backgroundColor:"#FFFFFF", "border-radius": "10px"}}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6} style={{position:"relative", "border-radius": "10px", border:"1px dotted gray"}}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                        <div className={classes.HeaderMenuSearchLabel}>{this.NSInforString("Bills_lbl_searchBar_plh")}</div>
                        <Autocomplete
                          id="textField1_autocomplete"
                          onKeyPress={this.headerMenu_btn_search_with_enter}
                          freeSolo
                          filterOptions={filterOptions}
                          {...defaultPropsCountry}
                          value={this.state.textField1}
                          inputValue={this.state.textField1_inputValue}
                          open={this.state.textField1_popoverOpen}
                          onClose={(event,value) => this.handleCustomDropDownClick_headerMenu_close(event,value)}
                          onInputChange={(event,value) => this.handleCustomDropDownClick_headerMenu_change(event,value)}
                          renderOption={option => {return (<React.Fragment>{option}</React.Fragment>);}}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={this.state.textField1_hasError}
                              label={this.NSInforString("Bills_lbl_searchBar_plh2")}
                              margin="normal"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <React.Fragment>
                                    <IconButton onClick={this.headerMenu_btn_search_with_icon} onMouseDown={this.headerMenu_btn_search_with_icon} size="small">
                                      <SearchIcon />
                                    </IconButton>
                                    {params.InputProps.startAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </GridItem>
                    {/*<GridItem xs={3} sm={3} md={3}>
                    <div style={{width:"100%", display:"inline-block", marginTop:20, textAlign:"center",}}>
                      <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_scan")}</div>
                      <Button onClick={this.Bills_header_scan_act}><div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_scan} alt=""/></div></Button>
                    </div>
                    </GridItem>*/}
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{backgroundColor:"#F7F7F7", "border-radius": "10px"}}>
                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_home_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_home} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_home")}</div>
                  </div>

                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_categories_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_categories} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_categories")}</div>
                  </div>

                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_history_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_history} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_history")}</div>
                  </div>

                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_favorites_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_favorites} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_favorites")}</div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
            {/* -------------------------------- */}
            {/* ----------[Favorites]----------- */}
            {/* -------------------------------- */}
            {this.state.searchResults_isHidden === false || this.state.parserObject_bills_favoritelist_res.length === 0 ? ( "" ) : (
              <div style={{ marginTop:20, paddingTop:10, paddingBottom:10, textAlign : "center", backgroundColor:"#F7F7F7",  "border-radius": "10px"}}>
                <div className={classes.FavoritesLabel}>{this.NSInforString("Bills_lbl_myFavorites")}</div>
                <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  {this.state.btn_favorite01_isHidden === true ? ( "" ) : (
                    <div style={{height:"50px", width:"25%", display:"inline-block"}}>
                      <div style={{padding:1, margin:1, textAlign : "center", border:"1px solid gray", "border-radius": "10px"}}>
                        <Button onClick={this.btn_favorite01_act}>
                        <div className={classes.favoriteButtonLabel}>{this.state.btn_favorite01}</div>
                        </Button>
                      </div>
                    </div>
                  )}
                  {this.state.btn_favorite02_isHidden === true ? ( "" ) : (
                    <div style={{height:"50px", width:"25%", display:"inline-block"}}>
                      <div style={{padding:1, margin:1, textAlign : "center", border:"1px solid gray", "border-radius": "10px"}}>
                        <Button onClick={this.btn_favorite02_act}>
                        <div className={classes.favoriteButtonLabel}>{this.state.btn_favorite02}</div>
                        </Button>
                      </div>
                    </div>
                  )}
                  {this.state.btn_favorite03_isHidden === true ? ( "" ) : (
                    <div style={{height:"50px", width:"25%", display:"inline-block"}}>
                      <div style={{padding:1, margin:1, textAlign : "center", border:"1px solid gray", "border-radius": "10px"}}>
                        <Button onClick={this.btn_favorite03_act}>
                        <div className={classes.favoriteButtonLabel}>{this.state.btn_favorite03}</div>
                        </Button>
                      </div>
                    </div>
                  )}
                  {this.state.btn_favorite04_isHidden === true ? ( "" ) : (
                    <div style={{height:"50px", width:"25%", display:"inline-block"}}>
                      <div style={{padding:1, margin:1, textAlign : "center", border:"1px solid gray", "border-radius": "10px"}}>
                        <Button onClick={this.btn_favorite04_act}>
                        <div className={classes.favoriteButtonLabel}>{this.state.btn_favorite04}</div>
                        </Button>
                      </div>
                    </div>
                  )}
                </GridItem>
                </GridContainer>
              </div>
            )}
            {/* -------------------------------- */}
            {/* ----------[Empty List]---------- */}
            {/* -------------------------------- */}
            {this.state.searchResults_isHidden === true && this.state.viewPleaseWait_hidden === true && this.state.parserObject_bills_billsHistory_res.length === 0 ? (
              <div style={{marginTop:20, marginBottom:20, backgroundColor:"#F7F7F7", "border-radius": "10px"}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.Bills_nohistory_lbl1}>{this.NSInforString("Bills_nobills_lbl1")}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12} style={{ marginLeft: 20}}>
                    <div className={classes.label1}>{this.NSInforString("Bills_nobills_lbl2")}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} style={{ marginLeft: 20}}>
                    <div style={{ marginTop: 10}}></div>
                    <div className={classes.label1}>&nbsp;</div>
                  </GridItem>
                  {/* <GridItem xs={12} sm={12} md={12} style={{ marginLeft: 20}}>
                    <div style={{ marginTop: 25}}></div>
                    <div className={classes.label1}>{this.NSInforString("Bills_slide1_lbl")}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} style={{ marginLeft: 20}}>
                    <div style={{ marginTop: 5}}></div>
                    <div className={classes.label1}>{this.NSInforString("Bills_slide2_lbl")}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} style={{ marginLeft: 20, marginBottom:10}}>
                    <div style={{ marginTop: 5}}></div>
                    <div className={classes.label1}>{this.NSInforString("Bills_slide3_lbl")}</div>
                  </GridItem> */}
                </GridContainer>
              </div>
            ) : (
              ""
            )}
            {/* -------------------------------- */}
            {/* ----------[Items List]---------- */}
            {/* -------------------------------- */}
            {this.state.searchResults_isHidden === false || this.state.parserObject_bills_billsHistory_res.length === 0 ? ( "" ) : (
              <div style={{marginTop:20, marginBottom:20, backgroundColor:"#F7F7F7", "border-radius": "10px"}}>
                <div style={{backgroundColor:"#F7F7F7", "border-radius": "10px"}}>&nbsp;</div>
                <div className={classes.TransactionsLabel}>{this.NSInforString("Bills_table_Recent")}</div>
                <List component="nav" aria-label="main mailbox folders" style={{backgroundColor:"#F7F7F7", "border-radius": "10px"}}>
                  {this.state.parserObject_bills_billsHistory_res.map(e => (
                    <React.Fragment key={"fragmentId_"+e.transId}>
                      <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_transaction(e)}>
                        <GridContainer justify="center">
                          {this.get_logoUrl_FromObj(e) !== "" && this.get_logoUrl_FromObj(e).indexOf(".png") > -1 ?
                          <GridItem xs={2} sm={2} md={2}>
                            <GridContainer justify="center">
                              <div className={classes.companyIcon}><img src={this.get_logoUrl_FromObj(e)} alt="companyIcon" /></div>
                            </GridContainer>
                          </GridItem>
                          :
                          (
                            <GridItem xs={2} sm={2} md={2}>
                              <GridContainer justify="center">
                                <div className={classes.companyIcon}><img src={Bills_Company_Placeholder} alt="companyIcon" /></div>
                              </GridContainer>
                            </GridItem>
                          )}
                          <GridItem xs={10} sm={10} md={10}>
                            <GridContainer justify="center">
                              <GridItem xs={6} sm={6} md={6}><div style={{textAlign:"left"}}><span className={classes.listItem_companyName}>{this.get_companyNameHistory_FromObj(e)}</span></div></GridItem>
                              <GridItem xs={6} sm={6} md={6}><div style={{textAlign:"right"}}><span className={classes.listItem_amount}>{this.get_amount_FromObj(e)}</span> <span className={classes.listItem_currency}>EUR</span></div></GridItem>
                              <GridItem xs={6} sm={6} md={6}><div style={{textAlign:"left"}}><span className={classes.listItem_date}>{this.get_date_FromObj(e)}</span></div></GridItem>
                              <GridItem xs={6} sm={6} md={6}><div style={{textAlign:"right", color:this.get_statusColor_FromObj(e) }}><span className={classes.listItem_status}>{this.get_status_FromObj(e)}</span></div></GridItem>
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </div>
            )}
            {/* -------------------------------- */}
            {/* ----------[Search Results]------ */}
            {/* -------------------------------- */}
            {this.state.searchResults_isHidden === true ? ( "" ) : (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.searchResults_arr.map(e => (
                    <React.Fragment key={"fragmentIdSearchResults_"+e.id}>
                      <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_company(e)}>
                        <GridContainer justify="center">
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>

                          <GridItem xs={10} sm={10} md={10}><div className={classes.listItem_fullName}>{this.get_companyName_FromObj(e)}</div></GridItem>
                          <GridItem xs={2} sm={2} md={2}><div style={{textAlign:"right"}}><img src={wu_bills_grayArrow} alt="wu_bills_grayArrow" /></div></GridItem>

                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                        </GridContainer>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </div>
            )}
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center" style={{marginTop:20, marginBottom:20}}>
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP checkAppVersion]------ */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_checkAppVersion_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_checkAppVersion_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_checkAppVersion_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_checkAppVersion} color="default" onClick={this.dialog_checkAppVersion_btn_ok}>{this.NSInforString("dialog_checkAppVersion_btn_ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP bpdone]---------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_bpdone_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_bpdone_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_bpdone_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_bpdone} color="default" onClick={this.dialog_bpdone_btn_ok}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }

  //-------------------------------------------------------------------------------------------------------------------------------
  buildUI(){
      let methName = filename+"buildUI ";
      if(api.print_logs){console.log(methName);}

      var parserObject_bills_favoritelist_res = null;
      try{ parserObject_bills_favoritelist_res = (JSON.parse(localStorage.getItem("parserObject_bills_favoritelist_res"))) ;}catch(err){console.log(methName+'err='+err);}

      var lbl_noFavorites_isHidden = true;
      var btn_favorite01_isHidden = true;
      var btn_favorite02_isHidden = true;
      var btn_favorite03_isHidden = true;
      var btn_favorite04_isHidden = true;
      var btn_favorite01 = "";
      var btn_favorite02 = "";
      var btn_favorite03 = "";
      var btn_favorite04 = "";

      if(parserObject_bills_favoritelist_res.length === 0){
          if(api.print_logs){console.log(methName+"parserObject_bills_favoritelist_res.length="+parserObject_bills_favoritelist_res.length);}
          lbl_noFavorites_isHidden = false;
          //let text1 = ""; let aItem1 = parserObject_bills_favoritelist_res[0]; text1 = aItem1["alias"]
          //let text2 = ""; let aItem2 = parserObject_bills_favoritelist_res[1]; text2 = aItem2["alias"]
          //let text3 = ""; let aItem3 = parserObject_bills_favoritelist_res[2]; text3 = aItem3["alias"]
          //let text4 = ""; let aItem4 = parserObject_bills_favoritelist_res[3]; text4 = aItem4["alias"]
          btn_favorite01_isHidden = true;
          btn_favorite02_isHidden = true;
          btn_favorite03_isHidden = true;
          btn_favorite04_isHidden = true;
      }
      else if(parserObject_bills_favoritelist_res.length === 1){
          if(api.print_logs){console.log(methName+"parserObject_bills_favoritelist_res.length="+parserObject_bills_favoritelist_res.length);}
          lbl_noFavorites_isHidden = true;
          let text1 = ""; let aItem1 = parserObject_bills_favoritelist_res[0]; text1 = aItem1["alias"]
        //let text2 = ""; let aItem2 = parserObject_bills_favoritelist_res[1]; text2 = aItem2["alias"]
        //let text3 = ""; let aItem3 = parserObject_bills_favoritelist_res[2]; text3 = aItem3["alias"]
        //let text4 = ""; let aItem4 = parserObject_bills_favoritelist_res[3]; text4 = aItem4["alias"]
          btn_favorite01_isHidden = false;    btn_favorite01 = text1;
          btn_favorite02_isHidden = true;  //btn_favorite02 = text2;
          btn_favorite03_isHidden = true;  //btn_favorite03 = text3;
          btn_favorite04_isHidden = true;  //cell.btn_favorite04.addTarget(  self, action: #selector(btn_favorite04_act(_:)),   for: .touchUpInside); btn_favorite04 = text4;
      }
      else if(parserObject_bills_favoritelist_res.length === 2){
          if(api.print_logs){console.log(methName+"parserObject_bills_favoritelist_res.length="+parserObject_bills_favoritelist_res.length);}
          lbl_noFavorites_isHidden = true;
          let text1 = ""; let aItem1 = parserObject_bills_favoritelist_res[0]; text1 = aItem1["alias"]
          let text2 = ""; let aItem2 = parserObject_bills_favoritelist_res[1]; text2 = aItem2["alias"]
        //let text3 = ""; let aItem3 = parserObject_bills_favoritelist_res[2]; text3 = aItem3["alias"]
        //let text4 = ""; let aItem4 = parserObject_bills_favoritelist_res[3]; text4 = aItem4["alias"]
          btn_favorite01_isHidden = false;   btn_favorite01 = text1;
          btn_favorite02_isHidden = false;   btn_favorite02 = text2;
          btn_favorite03_isHidden = true;  //btn_favorite03 = text3;
          btn_favorite04_isHidden = true;  //cell.btn_favorite04.addTarget(  self, action: #selector(btn_favorite04_act(_:)),   for: .touchUpInside); btn_favorite04 = text4;
      }
      else if(parserObject_bills_favoritelist_res.length === 3){
          if(api.print_logs){console.log(methName+"parserObject_bills_favoritelist_res.length="+parserObject_bills_favoritelist_res.length);}
          lbl_noFavorites_isHidden = true;
          let text1 = ""; let aItem1 = parserObject_bills_favoritelist_res[0]; text1 = aItem1["alias"]
          let text2 = ""; let aItem2 = parserObject_bills_favoritelist_res[1]; text2 = aItem2["alias"]
          let text3 = ""; let aItem3 = parserObject_bills_favoritelist_res[2]; text3 = aItem3["alias"]
        //let text4 = ""; let aItem4 = parserObject_bills_favoritelist_res[3]; text4 = aItem4["alias"]
          btn_favorite01_isHidden = false;   btn_favorite01 = text1;
          btn_favorite02_isHidden = false;   btn_favorite02 = text2;
          btn_favorite03_isHidden = false;   btn_favorite03 = text3;
          btn_favorite04_isHidden = true;  //cell.btn_favorite04.addTarget(  self, action: #selector(btn_favorite04_act(_:)),   for: .touchUpInside); btn_favorite04 = text4;
      }
      else if(parserObject_bills_favoritelist_res.length > 3){
          if(api.print_logs){console.log(methName+"parserObject_bills_favoritelist_res.length="+parserObject_bills_favoritelist_res.length);}
          lbl_noFavorites_isHidden = true;
          let text1 = ""; let aItem1 = parserObject_bills_favoritelist_res[0]; text1 = aItem1["alias"]
          let text2 = ""; let aItem2 = parserObject_bills_favoritelist_res[1]; text2 = aItem2["alias"]
          let text3 = ""; let aItem3 = parserObject_bills_favoritelist_res[2]; text3 = aItem3["alias"]
        //let text4 = ""; let aItem4 = parserObject_bills_favoritelist_res[3]; text4 = aItem4["alias"]
          let text4 = this.NSInforString("Bills_item_seeAll");
          btn_favorite01_isHidden = false;   btn_favorite01 = text1;
          btn_favorite02_isHidden = false;   btn_favorite02 = text2;
          btn_favorite03_isHidden = false;   btn_favorite03 = text3;
          btn_favorite04_isHidden = false;   btn_favorite04 = text4;
      }

      this.setState({
        "lbl_noFavorites_isHidden"    : lbl_noFavorites_isHidden,
        "btn_favorite01_isHidden"     : btn_favorite01_isHidden,
        "btn_favorite02_isHidden"     : btn_favorite02_isHidden,
        "btn_favorite03_isHidden"     : btn_favorite03_isHidden,
        "btn_favorite04_isHidden"     : btn_favorite04_isHidden,
        "btn_favorite01"              : btn_favorite01.length > 14 ? btn_favorite01.substring(0,14)+"..." : btn_favorite01,
        "btn_favorite02"              : btn_favorite02.length > 14 ? btn_favorite02.substring(0,14)+"..." : btn_favorite02,
        "btn_favorite03"              : btn_favorite03.length > 14 ? btn_favorite03.substring(0,14)+"..." : btn_favorite03,
        "btn_favorite04"              : btn_favorite04.length > 14 ? btn_favorite04.substring(0,14)+"..." : btn_favorite04,
      });

      if(localStorage.getItem("registerLight2_to_bills_showPopup")==="true"){
        localStorage.setItem("registerLight2_to_bills_showPopup", "false");
        this.dialog_bpdone_handleOpen(this.NSInforString("RegisterLight2_bpdone"),"NET");
      }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  onListItemClick_transaction(obj){
    let methName = filename+"onListItemClick_transaction ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    localStorage.setItem("parserObject_bills_billsHistoryDetail_res", JSON.stringify(obj));
    //++++++++++++++++++
    //BillsHistoryDetail
    //++++++++++++++++++
    localStorage.setItem("triggerRefresh_Bills","false");
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    localStorage.setItem("BillsHistoryDetail_prev_view","Bills");
    history.push(wu_Utilities.getNavigationURLs("BillsHistoryDetail"));
  }
  //----------------------------------------------------------------------------------------------------
  onListItemClick_company(obj){

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    let ws_billId = obj.id;

    var parserObject_bills_payment_info_billPayment_req = {};
    parserObject_bills_payment_info_billPayment_req["billerId"] = ws_billId;
    localStorage.setItem("parserObject_bills_payment_info_billPayment_req", JSON.stringify(parserObject_bills_payment_info_billPayment_req));
    localStorage.setItem("bills_billerId", ws_billId+"");

    localStorage.setItem("billPaymentSetup_ws","billPayment");
    //+++++++++++++++++
    //BillsPaymentSetup
    //+++++++++++++++++
    localStorage.setItem("BillsPaymentSetup_prev_view","Bills");
    history.push(wu_Utilities.getNavigationURLs("BillsPaymentSetup"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //header menu - drop down
  handleCustomDropDownClick_headerMenu_change(event,value) {
    let methName = filename+"handleCustomDropDownClick_headerMenu_change ";
    let event_target_value = (event===null || event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}

    eventTMP = eventTMP.toUpperCase();
    //console.log(methName+"["+eventTMP+"]");
    if(eventTMP.length>=AUTOCOMPLETE_MIN_CHARACTERS_OPEN_POPUP){
      this.setState({"textField1_inputValue":eventTMP});
      this.setState({"textField1_popoverOpen":true});
      this.setState({"textField1_hasError":false});
    }
    else{
      this.setState({"textField1_inputValue":eventTMP});
      this.setState({"textField1_popoverOpen":false});
      this.setState({"textField1_hasError":false});
    }
    if(eventTMP===""){
      this.setState({"searchResults_isHidden":true });
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_headerMenu_close(event,value) {
    let methName = filename+"handleCustomDropDownClick_headerMenu_close ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}

    this.setState({"textField1_popoverOpen":false});
    //document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //header menu
  Bills_header_scan_act(event) {
    let methName = filename+"Bills_header_scan_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    //history.push(wu_Utilities.getNavigationURLs("BillsScanner"));
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_home_act(event) {
    let methName = filename+"Bills_header_home_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(localStorage.getItem("curr_view").trim() !== "Bills"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("Bills"));
    }
    else{
      this.setState({
        "textField1_inputValue":"",
        "textField1_popoverOpen":false,
        "textField1_hasError":false,
        "searchResults_isHidden":true,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_categories_act(event) {
    let methName = filename+"Bills_header_categories_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(localStorage.getItem("curr_view").trim() !== "BillsCategories"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsCategories"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_history_act(event) {
    let methName = filename+"Bills_header_history_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(localStorage.getItem("curr_view").trim() !== "BillsHistory"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsHistory"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_favorites_act(event) {
    let methName = filename+"Bills_header_favorites_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(localStorage.getItem("curr_view").trim() !== "BillsFavorites"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsFavorites"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_favorite01_act(event) {
    let methName = filename+"btn_favorite01_act ";
    if(api.print_logs){console.log(methName);}

    let ind = 0;
    let parserObject_bills_favoritelistDetail = this.state.parserObject_bills_favoritelist_res[ind];
    localStorage.setItem("parserObject_bills_favoritelistDetail", JSON.stringify(parserObject_bills_favoritelistDetail));
    //++++++++++++++++++
    //BillsHistoryDetail
    //++++++++++++++++++
    localStorage.setItem("triggerRefresh_Bills","false");
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    localStorage.setItem("BillsFavoritesDetail_prev_view","Bills");
    history.push(wu_Utilities.getNavigationURLs("BillsFavoritesDetail"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_favorite02_act(event) {
    let methName = filename+"btn_favorite02_act ";
    if(api.print_logs){console.log(methName);}

    let ind = 1;
    let parserObject_bills_favoritelistDetail = this.state.parserObject_bills_favoritelist_res[ind];
    localStorage.setItem("parserObject_bills_favoritelistDetail", JSON.stringify(parserObject_bills_favoritelistDetail));
    //++++++++++++++++++
    //BillsHistoryDetail
    //++++++++++++++++++
    localStorage.setItem("triggerRefresh_Bills","false");
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    localStorage.setItem("BillsFavoritesDetail_prev_view","Bills");
    history.push(wu_Utilities.getNavigationURLs("BillsFavoritesDetail"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_favorite03_act(event) {
    let methName = filename+"btn_favorite03_act ";
    if(api.print_logs){console.log(methName);}

    let ind = 2;
    let parserObject_bills_favoritelistDetail = this.state.parserObject_bills_favoritelist_res[ind];
    localStorage.setItem("parserObject_bills_favoritelistDetail", JSON.stringify(parserObject_bills_favoritelistDetail));
    //++++++++++++++++++
    //BillsHistoryDetail
    //++++++++++++++++++
    localStorage.setItem("triggerRefresh_Bills","false");
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    localStorage.setItem("BillsFavoritesDetail_prev_view","Bills");
    history.push(wu_Utilities.getNavigationURLs("BillsFavoritesDetail"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_favorite04_act(event) {
    let methName = filename+"btn_favorite04_act ";
    if(api.print_logs){console.log(methName);}

    if(this.state.parserObject_bills_favoritelist_res.length > 3){
      //++++++++++++++++++
      //BillsHistoryDetail
      //++++++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsFavorites"));
    }
    else{
      let ind = 3;
      let parserObject_bills_favoritelistDetail = this.state.parserObject_bills_favoritelist_res[ind];
      localStorage.setItem("parserObject_bills_favoritelistDetail", JSON.stringify(parserObject_bills_favoritelistDetail));
      //++++++++++++++++++
      //BillsHistoryDetail
      //++++++++++++++++++
      localStorage.setItem("triggerRefresh_Bills","false");
      localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
      localStorage.setItem("BillsFavoritesDetail_prev_view","Bills");
      history.push(wu_Utilities.getNavigationURLs("BillsFavoritesDetail"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  NSInforString_withLang(aKey,lang){
    if(lang==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else           { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  //----------------------------------------------------------------------------------------------------
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities CategoriesCompanies---------------------
  //----------------------------------------------------------------------------------------------------
  process_CategoriesCompaniesObject(){
    let methName = filename+"process_CategoriesCompaniesObject ";
    if(api.print_logs){console.log(methName);}

    let categoryFieldDescr = localStorage.getItem("lang")==="el" ? "categoryEl" : "categoryEn";
    var parserObject_categoriesList = [];
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
       let category   = "";
       var categoryEl = "";
       var categoryEn = "";
       var mid        = 0;
       try {category   = aItem[categoryFieldDescr]; }catch(err){;} if(category   === null || (typeof category   ==="undefined")){category   = "";}
       try {categoryEl = aItem["categoryEl"];       }catch(err){;} if(categoryEl === null || (typeof categoryEl ==="undefined")){categoryEl = "";}
       try {categoryEn = aItem["categoryEn"];       }catch(err){;} if(categoryEn === null || (typeof categoryEn ==="undefined")){categoryEn = "";}
       try {mid        = aItem["mid"];              }catch(err){;} if(mid        === null || (typeof mid        ==="undefined")){mid        = 0;}
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       if(wu_Utilities.bills_categoryExists(category, parserObject_categoriesList) === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = categoryEl;
           aCategory["categoryEn"] = categoryEn;
           aCategory["mid"]        = mid;
           parserObject_categoriesList.push(aCategory);
       }
    }

    parserObject_categoriesList.sort(function(a, b) {
      if( (a.category).localeCompare(b.category) === -1){ return -1; }
      if( (a.category).localeCompare(b.category) === 1){ return 1; }
      return 0;
    });

    var popularFound = false;
    for(var j=0; j<parserObject_categoriesCompaniesList.length; ++j){
       let aItem = parserObject_categoriesCompaniesList[j];
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       var popularity = 0;
       try {popularity = aItem["popularity"]; }catch(err){;} if(popularity === null || (typeof popularity ==="undefined")){popularity = 0;}
       let category = this.NSInforString("Bills_popular_category");
       if(popularity > 0 && popularFound === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = this.NSInforString_withLang("Bills_popular_category","el");
           aCategory["categoryEn"] = this.NSInforString_withLang("Bills_popular_category","en");
           aCategory["mid"]        = 1000000;
           parserObject_categoriesList.splice(0, 0, aCategory);//insert at index 0
           popularFound = true;
       }
    }

    this.setState({ "parserObject_categoriesList" : parserObject_categoriesList });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities Bills-----------------------------------
  //----------------------------------------------------------------------------------------------------
  bills_enrich_billsHistory(theList){
      let methName = filename+"bills_enrich_billsHistory ";
      if(api.print_logs){console.log(methName);}

      var parserObject_categoriesCompaniesList = null;
      try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

      var theList_new = [];
      for(var i=0; i<theList.length; ++i){
          let item = theList[i];
          var ws_billId = 0;
          try {ws_billId = item["billId"]; }catch(err){;} if(ws_billId === null || (typeof ws_billId ==="undefined")){ws_billId = 0;}

          let item_new = JSON.parse(JSON.stringify(item));
          item_new["_companyName"]     = wu_Utilities.bills_companyNameFromBillId(ws_billId, parserObject_categoriesCompaniesList);
          item_new["_companyKeywords"] = wu_Utilities.bills_companyKeywordsFromBillId(ws_billId, parserObject_categoriesCompaniesList);
          theList_new.push(item_new);
      }

      return theList_new;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities get data from Obj-----------------------
  //----------------------------------------------------------------------------------------------------
  get_logoUrl_FromObj(obj){
    let methName = filename+"get_logoUrl_FromObj ";
    //if(api.print_logs){console.log(methName);}

    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    if(obj){
      var imageURL = api.url + wu_Utilities.bills_images_urls(obj.billId,parserObject_categoriesCompaniesList);
      //if(api.print_logs){console.log(methName+"imageURL="+imageURL);}
      return imageURL;
    }

    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_companyNameHistory_FromObj(obj){
      //let methName = filename+"get_companyNameHistory_FromObj ";
      //if(api.print_logs){console.log(methName);}

      if(obj){
        return obj["_companyName"];
      }
      return ""
  }
  //----------------------------------------------------------------------------------------------------
  get_companyName_FromObj(obj){
      let methName = filename+"get_companyName_FromObj ";
      //if(api.print_logs){console.log(methName);}

      var parserObject_categoriesCompaniesList = null;
      try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

      if(obj){
        var companyName = wu_Utilities.bills_companyNameFromBillId(obj.id,parserObject_categoriesCompaniesList);
        //if(api.print_logs){console.log(methName+"companyName="+companyName);}
        return companyName;
      }
      return ""
  }
  //----------------------------------------------------------------------------------------------------
  get_date_FromObj(obj){
    //let methName = filename+"get_date_FromObj ";
    //if(api.print_logs){console.log(methName);}

    if(obj){ return wu_Utilities.bills_getFriendlyDate(obj.insDate); }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_amount_FromObj(obj){
    //let methName = filename+"get_amount_FromObj ";
    //if(api.print_logs){console.log(methName);}

    if(obj){ return wu_Utilities.bills_amount_with_comma(wu_Utilities.bills_normalizeAmount(obj.amount)); }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_status_FromObj(obj){
    //let methName = filename+"get_status_FromObj ";
    //if(api.print_logs){console.log(methName);}

    if(obj){
           if(obj.status === 82) { return this.NSInforString("Bills_status_code_success");  }
      else if(obj.status === 83) { return this.NSInforString("Bills_status_code_success");  }
      else if(obj.status === 84) { return this.NSInforString("Bills_status_code_canceled"); }
      else if(obj.status === 90) { return this.NSInforString("Bills_status_code_failure");  }
      else if(obj.status === 97) { return this.NSInforString("Bills_status_code_pending");  }
      else if(obj.status === 89) { return this.NSInforString("Bills_status_code_pending");  }//24/07/2023

      return this.NSInforString("Bills_status_code_failure");
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_statusColor_FromObj(obj){
    //let methName = filename+"get_statusColor_FromObj ";
    //if(api.print_logs){console.log(methName);}

    if(obj){
      let billsStatusText = wu_Utilities.bills_status_text(obj.status);
      if(billsStatusText === "success"){ return "#35B6B4"; } //35B6B4 (green)
      if(billsStatusText === "failure"){ return "#F10D0D"; } //F10D0D (red)
      if(billsStatusText === "pending"){ return "#FF931E"; } //FF931E (orange)
    }
    return "#000000";
  }
  //----------------------------------------------------------------------------------------------------
  get_alias_FromObj(obj){
    if(obj){
      return obj.alias;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities headermenu------------------------------
  //----------------------------------------------------------------------------------------------------
  //header menu - Utilities
  headerMenu_btn_search_isDisabled(){
    //if(this.verifyLength(this.state.textField1,1)===false){ return true; } //mtcn
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  headerMenu_btn_search_with_enter(event){
    if (event.charCode === 13) { // enter key pressed
      event.preventDefault();
      this.setState({
      //"textField1"          : "",
        "textField1_hasError" : false,
        "dialogS_isOpen"      : false,
      });
      setTimeout(function() {
        this.headerMenu_btn_search_logic(event);
      }.bind(this), 100);
    }
    //let this_state_textField1 = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    //console.log("headerMenu_btn_search_with_enter this_state_textField1="+this_state_textField1);
  }
  //----------------------------------------------------------------------------------------------------
  headerMenu_btn_search_with_icon(event){
    event.preventDefault();
    this.setState({
    //"textField1"          : "",
      "textField1_hasError" : false,
      "dialogS_isOpen"      : false,
    });
    setTimeout(function() {
      this.headerMenu_btn_search_logic(event);
    }.bind(this), 100);
    //let this_state_textField1 = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    //console.log("headerMenu_btn_search_with_icon this_state_textField1="+this_state_textField1);
  }
  //----------------------------------------------------------------------------------------------------
  headerMenu_btn_search_logic(event) {
    let methName = filename+"headerMenu_btn_search_logic ";
    if(api.print_logs){console.log(methName);}

    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    let keyword = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    console.log(methName+"keyword="+keyword);
    if(keyword.toUpperCase().startsWith("RF") && this.state.canSearchRF){
      this.makeHTTPConn_bills_info_inputSingleRF();
      return;
    }

    let pops_search_res = [];
    let this_state_textField1  = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value  : this.state.textField1;
    let searchTerm             =  this_state_textField1.trim();
    let search_S = new Date();
    let search_E = new Date();
    console.log(methName+"this_state_textField1  = "+this_state_textField1);
    console.log(methName+"searchTerm             = "+searchTerm);

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this_state_textField1.trim() === ""){
        this.setState({"textField1_hasError"  : true }); emptyFields = true;
        if(emptyFields===true){return;}
      }
    }

    if(!parserObject_categoriesCompaniesList){
        this.dialog_handleOpen(this.NSInforString("BillsSearch_msg02"));
        return;
    }
    if(this_state_textField1 === ""){
        this.dialog_handleOpen(this.NSInforString("BillsSearch_msg01"));
        return;
    }

    let TextField1Text_NoTone   = wu_Utilities.replaceTonoumena(this_state_textField1.trim().toUpperCase());
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    let TextField1Text_NoTone_arr = TextField1Text_NoTone.split(" ");

    search_S = new Date();
    pops_search_res = this.search_auxiliary(parserObject_categoriesCompaniesList,TextField1Text_NoTone_arr[0]);
    for (let j=0; j<TextField1Text_NoTone_arr.length; ++j) {
        pops_search_res = this.search_auxiliary(pops_search_res,TextField1Text_NoTone_arr[j]);
    }
    search_E = new Date();

    for(let i=0; i<pops_search_res.length; ++i){
      pops_search_res[i]["index"] = i+1;
    }

    if(api.print_logs){console.log(methName+"parserObject_categoriesCompaniesList.length = "+parserObject_categoriesCompaniesList.length);}
    if(api.print_logs){console.log(methName+"pops_search_res.length                      = "+pops_search_res.length);}
    if(api.print_logs){console.log(methName+"START                                       = "+search_S);}
    if(api.print_logs){console.log(methName+"END                                         = "+search_E);}
    if(pops_search_res.length===0){
        this.dialog_handleOpen(this.NSInforString("BillsSearch_msg02"));
    }
    else{
      //if(api.print_logs){console.log(methName+"pops_search_res = "+JSON.stringify(pops_search_res));}
      this.setState({
        "searchResults_isHidden" : false,
        "searchResults_arr"      : pops_search_res,
      });
    }

    if(keyword.startsWith("RF")===false){
      let tagManagerData = {
        'event'      : 'search_bills',
        'searchTerm' : searchTerm
      };
      //TagManager.dataLayer(tagManagerData);
      try { window.dataLayer.push(tagManagerData);                }catch(err1){console.log(methName+"err1="+err1);}
      try { console.log(methName+JSON.stringify(tagManagerData)); }catch(err2){console.log(methName+"err2="+err2);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  search_auxiliary(local_parserObject_categoriesCompaniesList,TextField1Text){
    let methName = filename+"search_auxiliary ";
    if(api.print_logs){console.log(methName);}

    let pops_search_res = [];

    let bill_id = 0;
    //----------
    let bpKeywords = "";
    let nameEl     = "";
    let nameEn     = "";
    //----------
    let bpKeywords_Index = -1;
    let nameEl_Index     = -1;
    let nameEn_Index     = -1;
    //----------
    let       isNotSearchResult = true;
    let       MAXRESULTS        = 750;
    let       foundResults      = 0;
    let TextField1Text_NoTone   = wu_Utilities.replaceTonoumena(TextField1Text.trim().toUpperCase());

    let aRow = null;
    let cnt = local_parserObject_categoriesCompaniesList.length;
    if(api.print_logs){console.log(methName+"cnt                    = "+cnt);}
    if(api.print_logs){console.log(methName+"Search START           = "+new Date());}
    for (let i=0; i<cnt; ++i) {
        aRow = local_parserObject_categoriesCompaniesList[i];
        isNotSearchResult = true;
        bpKeywords_Index  = -1;
        nameEl_Index      = -1;
        nameEn_Index      = -1;

        if(foundResults===MAXRESULTS){
            break;
        }
        try { bill_id = aRow["id"]; }catch(err){ bill_id = 0; }

        try { bpKeywords = aRow["bpKeywords"]; }catch(err){ bpKeywords = ""; } if(bpKeywords === null){bpKeywords = "";}
        try { nameEl     = aRow["nameEl"];     }catch(err){ nameEl     = ""; } if(nameEl     === null){nameEl     = "";}
        try { nameEn     = aRow["nameEn"];     }catch(err){ nameEn     = ""; } if(nameEn     === null){nameEn     = "";}

        bpKeywords_Index = wu_Utilities.replaceTonoumena(bpKeywords.toUpperCase()).indexOf(TextField1Text_NoTone);
        nameEl_Index     = wu_Utilities.replaceTonoumena(nameEl.toUpperCase()).indexOf(TextField1Text_NoTone);
        nameEn_Index     = wu_Utilities.replaceTonoumena(nameEn.toUpperCase()).indexOf(TextField1Text_NoTone);

        if (bpKeywords_Index !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")bpKeywords ="+bpKeywords);} }
        if (nameEl_Index     !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")nameEl     ="+nameEl);} }
        if (nameEn_Index     !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")nameEn     ="+nameEn);} }

        let already_exists = this.itemAlreadyExistsInArray(pops_search_res,bill_id);
        if(already_exists===true){
            isNotSearchResult = true;
        }
        if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aRow)===false){isNotSearchResult = true;}
        if(isNotSearchResult===false){
            aRow = null;
            try { aRow = local_parserObject_categoriesCompaniesList[i]; } catch(err){;}
            pops_search_res.push(aRow);
            foundResults = foundResults +1;
        }
    }
    //pops_search_res.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0));

    if(api.print_logs){console.log(methName+"Search END             = ",new Date());}
    if(api.print_logs){console.log(methName+"pops_search_res.length = "+pops_search_res.length);}
    return pops_search_res;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  itemAlreadyExistsInArray(searchArr,bill_id_search){
      if(bill_id_search===0){
          return false;
      }
      let bill_id = 0;
      let aRow = null;
      let cnt = searchArr.length;
      for(let i=0; i<cnt; ++i){
          aRow = searchArr[i];
          try { bill_id = aRow["id"]; }catch(err){ bill_id = 0; }
          if(bill_id===bill_id_search){
              return true;
          }
      }
      return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups checkAppVersion----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_checkAppVersion_isOpen" : true,
        "dialog_checkAppVersion_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_btn_ok(){
    window.location.reload(true);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups bpdone----------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_bpdone_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_bpdone_isOpen" : true,
        "dialog_bpdone_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_bpdone_btn_ok(){
    let methName = filename+"dialog_bpdone_btn_ok ";
    if(api.print_logs){console.log(methName);}

    this.setState({
      "dialog_bpdone_isOpen" : false,
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
}
Bills.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(BillsStyle)(Bills)
);
